import RpcClass from "../../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.engine.forms.schema.definition.FormDetailsConfig';

import LocalDate from "../../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../../server/LocalTime.js";



class FormDetailsConfig extends RpcClass{

    /**
     *  @class FormDetailsConfig
     *  @alias module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig
     *  
     *  @property {FormConfig} formConfig

     * */
    constructor(){
        super();

        /** @type {boolean}  */
        this.addEnabled = null;
        /** @type {string}  */
        this.addEnabledFlag = null;
        /** @type {boolean}  */
        this.allRecords = null;
        /** @type {boolean}  */
        this.cleanInvisible = null;
        /** @type {boolean}  */
        this.cloneInclude = null;
        /** @type {string}  */
        this.constructorFunction = null;
        /** @type {boolean}  */
        this.deleteEnabled = null;
        /** @type {string}  */
        this.deleteEnabledFlag = null;
        /** @type {string}  */
        this.detailsClass = null;
        /** @type {boolean}  */
        this.detailsEnabled = null;
        /** @type {string}  */
        this.detailsViewClass = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.enabledByFeatureFlags = null;
        /** @type {string}  */
        this.factoryType = null;
        /** @type {boolean}  */
        this.hasInitialFactory = null;
        /** @type {number}  */
        this.height = null;
        /** @type {boolean}  */
        this.isTwoLayerTemplate = null;
        /** @type {boolean}  */
        this.isView = null;
        /** @type {string}  */
        this.joiningField = null;
        /** @type {string}  */
        this.layout = null;
        /** @type {string}  */
        this.masterClass = null;
        /** @type {string}  */
        this.masterTab = null;
        /** @type {string}  */
        this.multiAddForeignKey = null;
        /** @type {string}  */
        this.name = null;
        /** @type {number}  */
        this.order = null;
        /** @type {boolean}  */
        this.showInAdd = null;
        /** @type {boolean}  */
        this.showInlineInAdd = null;
        /** @type {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}  */
        this.showInlineInAddEnabledByFeatureFlags = null;
        /** @type {module:src/server/com/silkplm/engine/forms/DetailStyle.DetailStyle}  */
        this.style = null;
        /** @type {string}  */
        this.tabName = null;
        /** @type {string}  */
        this.tabTitle = null;
        /** @type {boolean}  */
        this.templateAutoInsert = null;
        /** @type {string[]}  */
        this.templateCopyFields = null;
        /** @type {string}  */
        this.templateFilterBy = null;
        /** @type {string}  */
        this.templateToDetailJoinField = null;
        /** @type {module:src/server/com/silkplm/engine/forms/schema/TwoLayersTemplateConfig.TwoLayersTemplateConfig}  */
        this.twoLayersTemplateConfigFromAnnotation = null;
        /** @type {string}  */
        this.visibleFunction = null;
        /** @type {boolean}  */
        this.watch = null;

    }





    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withAddEnabled(val){
        this.addEnabled = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withAddEnabledFlag(val){
        this.addEnabledFlag = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withAllRecords(val){
        this.allRecords = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withCleanInvisible(val){
        this.cleanInvisible = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withCloneInclude(val){
        this.cloneInclude = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withConstructorFunction(val){
        this.constructorFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withDeleteEnabled(val){
        this.deleteEnabled = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withDeleteEnabledFlag(val){
        this.deleteEnabledFlag = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withDetailsClass(val){
        this.detailsClass = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withDetailsEnabled(val){
        this.detailsEnabled = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withDetailsViewClass(val){
        this.detailsViewClass = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withEnabledByFeatureFlags(val){
        this.enabledByFeatureFlags = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withFactoryType(val){
        this.factoryType = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withHasInitialFactory(val){
        this.hasInitialFactory = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withHeight(val){
        this.height = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withIsTwoLayerTemplate(val){
        this.isTwoLayerTemplate = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withIsView(val){
        this.isView = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withJoiningField(val){
        this.joiningField = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withLayout(val){
        this.layout = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withMasterClass(val){
        this.masterClass = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withMasterTab(val){
        this.masterTab = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withMultiAddForeignKey(val){
        this.multiAddForeignKey = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withName(val){
        this.name = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withOrder(val){
        this.order = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withShowInAdd(val){
        this.showInAdd = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withShowInlineInAdd(val){
        this.showInlineInAdd = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withShowInlineInAddEnabledByFeatureFlags(val){
        this.showInlineInAddEnabledByFeatureFlags = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/DetailStyle.DetailStyle}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withStyle(val){
        this.style = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTabName(val){
        this.tabName = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTabTitle(val){
        this.tabTitle = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTemplateAutoInsert(val){
        this.templateAutoInsert = val;
        return this;
    };


    /**
     * @param val {string[]}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTemplateCopyFields(val){
        this.templateCopyFields = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTemplateFilterBy(val){
        this.templateFilterBy = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTemplateToDetailJoinField(val){
        this.templateToDetailJoinField = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/forms/schema/TwoLayersTemplateConfig.TwoLayersTemplateConfig}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withTwoLayersTemplateConfigFromAnnotation(val){
        this.twoLayersTemplateConfigFromAnnotation = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withVisibleFunction(val){
        this.visibleFunction = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig.FormDetailsConfig}
     */
    withWatch(val){
        this.watch = val;
        return this;
    };





    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};
metadata['addEnabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['addEnabledFlag'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['allRecords'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cleanInvisible'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['cloneInclude'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['constructorFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deleteEnabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['deleteEnabledFlag'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['detailsEnabled'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['detailsViewClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['enabledByFeatureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['factoryType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['hasInitialFactory'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['height'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['isTwoLayerTemplate'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isView'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['joiningField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['layout'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['masterClass'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['masterTab'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['multiAddForeignKey'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['name'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['order'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['showInAdd'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showInlineInAdd'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['showInlineInAddEnabledByFeatureFlags'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'jsType' : 'module:src/server/com/silkplm/rpc/FeatureFlag.FeatureFlag[]', 'mapped' : 'false'};
metadata['style'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/DetailStyle.DetailStyle', 'jsType' : 'module:src/server/com/silkplm/engine/forms/DetailStyle.DetailStyle', 'mapped' : 'false'};
metadata['tabName'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['tabTitle'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['templateAutoInsert'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['templateCopyFields'] = {'remoteType' : 'string[]', 'jsType' : 'string[]', 'mapped' : 'false'};
metadata['templateFilterBy'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['templateToDetailJoinField'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['twoLayersTemplateConfigFromAnnotation'] = {'remoteType' : 'module:src/server/com/silkplm/engine/forms/schema/TwoLayersTemplateConfig.TwoLayersTemplateConfig', 'jsType' : 'module:src/server/com/silkplm/engine/forms/schema/TwoLayersTemplateConfig.TwoLayersTemplateConfig', 'mapped' : 'false'};
metadata['visibleFunction'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['watch'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.engine.forms.schema.definition.FormDetailsConfig';
metadata.__type_short__ = 'FormDetailsConfig';
FormDetailsConfig.prototype.__metadata__ = metadata;

FormDetailsConfig.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig */
export default FormDetailsConfig

export { FormDetailsConfig }
